/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Cmp_Web_LabelInputs */

const en_fc_cmp_web_label = /** @type {(inputs: Fc_Cmp_Web_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Runs in a browser`)
};

/**
* | output |
* | --- |
* | "Runs in a browser" |
*
* @param {Fc_Cmp_Web_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_cmp_web_label = /** @type {((inputs?: Fc_Cmp_Web_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Cmp_Web_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_cmp_web_label(inputs)
});
export { fc_cmp_web_label as "fc.cmp.web.label" }